// src/Pages/Admin/Sesion/NuevaSesionForm.js
import React, { useState } from "react";
import { Plus, CalendarDays } from "lucide-react";

const NuevaSesionForm = ({
  nuevaSesion,
  setNuevaSesion,
  usuariosCliente = [],
  loading,
  onCrear,
  onCancelar,
}) => {
  const [errores, setErrores] = useState({});

  const setCampo = (campo, valor) => {
    setNuevaSesion((prev) => ({ ...prev, [campo]: valor }));
    setErrores((prev) => ({ ...prev, [campo]: null }));
  };

  const validar = () => {
    const nuevos = {};
    if (!nuevaSesion.nombre?.trim()) nuevos.nombre = "Poné un nombre para identificar la sesión.";
    if (!nuevaSesion.fecha) nuevos.fecha = "Elegí la fecha de la sesión.";
    else if (new Date(nuevaSesion.fecha) > new Date()) nuevos.fecha = "La fecha no puede ser futura.";
    setErrores(nuevos);
    return Object.keys(nuevos).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validar()) return;
    await onCrear();
  };

  return (
    <form className="sg-panel" onSubmit={handleSubmit} noValidate>
      <h3 className="sg-detail-title">Nueva sesión</h3>

      <div className="sg-field">
        <label className="sg-label" htmlFor="sg-nombre">
          Nombre
        </label>
        <input
          id="sg-nombre"
          type="text"
          className="sg-input"
          value={nuevaSesion.nombre || ""}
          onChange={(e) => setCampo("nombre", e.target.value)}
          placeholder="Ej: Book-thin, Sesión playa"
          aria-invalid={Boolean(errores.nombre)}
        />
        {errores.nombre && <p className="sg-field-error">{errores.nombre}</p>}
      </div>

      <div className="sg-grid-2">
        <div className="sg-field">
          <label className="sg-label" htmlFor="sg-fecha">
            <CalendarDays size={13} /> Fecha
          </label>
          <input
            id="sg-fecha"
            type="date"
            className="sg-input"
            value={nuevaSesion.fecha || ""}
            onChange={(e) => setCampo("fecha", e.target.value)}
            aria-invalid={Boolean(errores.fecha)}
          />
          {errores.fecha && <p className="sg-field-error">{errores.fecha}</p>}
        </div>

        <div className="sg-field">
          <label className="sg-label" htmlFor="sg-cliente">
            Cliente
          </label>
          <select
            id="sg-cliente"
            className="sg-select"
            value={nuevaSesion.usuario_id || ""}
            onChange={(e) => setCampo("usuario_id", e.target.value)}
          >
            <option value="">Sin asignar</option>
            {usuariosCliente.map((u) => (
              <option key={u.id} value={u.id}>
                {u.nombre || u.email || u.id}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="sg-field">
        <label className="sg-label" htmlFor="sg-estado">
          Estado
        </label>
        <select
          id="sg-estado"
          className="sg-select"
          value={nuevaSesion.estado || "pendiente"}
          onChange={(e) => setCampo("estado", e.target.value)}
        >
          <option value="pendiente">Pendiente</option>
          <option value="en_proceso">En proceso</option>
          <option value="completada">Completada</option>
        </select>
      </div>

      <div className="sg-field">
        <label className="sg-label" htmlFor="sg-desc">
          Descripción
        </label>
        <textarea
          id="sg-desc"
          className="sg-textarea"
          value={nuevaSesion.descripcion || ""}
          onChange={(e) => setCampo("descripcion", e.target.value)}
          placeholder="Notas internas sobre la sesión (opcional)"
        />
      </div>

      <div className="sg-form-actions">
        <button type="submit" className="sg-btn" disabled={loading}>
          <Plus size={16} /> {loading ? "Creando..." : "Crear sesión"}
        </button>
        <button type="button" className="sg-btn sg-btn--ghost" onClick={onCancelar}>
          Cancelar
        </button>
      </div>
    </form>
  );
};

export default NuevaSesionForm;